import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getRplLainnya = 'sertifikasi-rpl';
const getDetailRplLainnya = 'sertifikasi-rpl/';
const postRplLainnyaUrl = 'sertifikasi-rpl';
const putRplWorkshop = 'sertifikasi-rpl/';
const deleteDokumen = 'sertifikasi-rpl/delete-dokumen-sertifikasi-rpl/'
const deleteRplWorkshop = 'sertifikasi-rpl/delete-sertifikasi-rpl/';
const deleteMataUji = 'sertifikasi-rpl/delete-sertifikasi-rpl-mata-uji/';
const deleteInstruktur = 'sertifikasi-rpl/delete-instruktur-sertifikasi-rpl/'
const getDataPeserta = 'sertifikasi-rpl/peserta';
const getDetailMataUjiPeserta = 'sertifikasi-rpl/data-peserta/get-data-mata-uji/'
const absenPeserta = 'sertifikasi-rpl/data-peserta/absensi-peserta/'
const getDokumenRplPeserta = 'jadwal-test-center/dokumen-pendukung-peserta-rpl';
const verifikasiDokumen = 'jadwal-test-center/data-peserta/verifikasi-dokumen-pendukung-one-unit/';
class RplLainnyaService {
    getRplLainnya(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getRplLainnya + '?pageNo=' + currentPage + '&pageSize=' +  pageSize  + '&filter=' + filter + '&kategoriRpl=RPL Lainnya',
        {
            headers: authHeader()
        });
    }

    verifikasiDokumenPeserta(formData) {
        return axios.put(
            API_URL + verifikasiDokumen + formData.idDokumenPendukungRpl ,
            formData,
            { headers: { 'Content-Type': 'application/json','Authorization' : tokenHeader() } });
    }

    getDokumenRplPeserta(id_sertifikasi_rpl_peserta) {
        return axios.get(
            API_URL + getDokumenRplPeserta + '?idSertifikasiRplPeserta='+ id_sertifikasi_rpl_peserta,
        {
            headers: authHeader()
        });
        
    }

    absenPeserta(formData) {
        return axios.put(
            API_URL + absenPeserta + formData.idSertifikasiRplPeserta,
            formData,
            { headers: authHeader() }
        );
    }

    getDataPeserta(currentPage,pageSize,filter,idSertifikasiRpl) {
        return axios.get(
            API_URL + getDataPeserta + '?pageNo=' + currentPage + '&pageSize=' +  pageSize  + '&filter=' + filter +'&id_sertifikasi_rpl='+idSertifikasiRpl,
            {
                headers: authHeader()
            });
    }

    getDetailMataUjiPeserta(id_sertifikasi_rpl_peserta) {
        return axios.get(
            API_URL + getDetailMataUjiPeserta + id_sertifikasi_rpl_peserta ,
            {
                headers: authHeader()
            });
    }

    getDetailRplLainnya(idSertifikasiRpl) {
        return axios.get(
            API_URL + getDetailRplLainnya + idSertifikasiRpl,
            {
                headers: authHeader()
            });
    }

    postRplLainnya(formData) {
        
        return axios
            .post(
                API_URL + postRplLainnyaUrl,
                formData,
                {
                    headers: authHeader()
                }
            );
    }

    putRplWorkshop(formData) {
   
    }

    deleteDokumen(value) {
        return axios
        .delete(
            API_URL + deleteDokumen + value.id_dokumen_pendukung_sertifikasi_rpl,
            { headers: authHeader() }
        );
    }

    deleteInstruktur(value) {
        return axios
        .delete(
            API_URL + deleteInstruktur + value.id_instruktur_sertifikasi_rpl,
            { headers: authHeader() }
        );
    }

    deleteMataUji(value) {
        return axios
            .delete(
                API_URL + deleteMataUji+ value.id_sertifikasi_rpl_mata_uji,
                { headers: authHeader() }
            );
    }

    deleteRplWorkshop(formData) {
        return axios
            .delete(
                API_URL + deleteRplWorkshop + formData,
                { headers: authHeader() }
            );
    }

}

export default new RplLainnyaService();
